export const formatDate = (date) => {
  if (isNaN(new Date(date).getDate())) {
    return date;
  }
  const day = new Date(date).getDate();
  const month = new Date(date).getMonth() + 1;
  const year = new Date(date).getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateTime = (date) => {
  console.log(date);

  if (isNaN(new Date(date).getDate())) {
    return date;
  }

  return new Date(date).toLocaleString("en-US");
};
